import { Overlay } from "@angular/cdk/overlay";
import { Component } from "@angular/core";
import { ConditionListsAgreementModel } from "../../../models/components/condition-lists-agreement.model";
import { ConditionListsPopUpService } from "../../../services/components/condition-lists-pop-up.service";
import { DialogService } from "../../../services/components/dialog.service";
import { ProductPopUpBaseComponent } from "../product-pop-up-base/product-pop-up-base.component";

@Component({
    selector: "pcg-ng-condition-lists-popup",
    template: require('./condition-lists-pop-up.component.html')
})
export class ConditionListsPopUpComponent extends ProductPopUpBaseComponent<ConditionListsAgreementModel> {
    public constructor(
        popupService: ConditionListsPopUpService,
        overlay: Overlay,
        dialogService: DialogService
    ) {
        super(popupService, overlay, dialogService);
    }
}
